import { Routes as RouterRoutes, Route } from "react-router-dom";
import { Pages } from "./Pages";

function Routes() {
  return (
    <RouterRoutes>
      <Route path="/*" element={<Pages />} />
    </RouterRoutes>
  );
}

export { Routes };
